import { render, staticRenderFns } from "./drag-input.vue?vue&type=template&id=5b4981ed&scoped=true&"
import script from "./drag-input.vue?vue&type=script&lang=js&"
export * from "./drag-input.vue?vue&type=script&lang=js&"
import style0 from "./drag-input.vue?vue&type=style&index=0&id=5b4981ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4981ed",
  null
  
)

export default component.exports